import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { ImageDetailsContract } from '@polaris-customerweb/sharedcomponents.core';
import {
    Image,
    RoutingHelpersService,
} from '@polaris-customerweb/sharedcomponents.shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ImageResourceService {
    private baseUrl: string;
    private moderateUrl: string;

    constructor(
        configService: ConfigService,
        private http: HttpClient,
        private routingHelpersService: RoutingHelpersService
    ) {
        this.baseUrl = routingHelpersService.combineUrl(
            configService.apiUrl.rideCommand,
            'v1/images'
        );
        this.moderateUrl = routingHelpersService.combineUrl(
            this.baseUrl,
            'moderate'
        );
    }

    uploadImage(formData: FormData, timeStamp?: string): Observable<Image> {
        let params: HttpParams | undefined;

        if (timeStamp) {
            params = new HttpParams().set('timestamp', timeStamp);
        }

        return this.http
            .post<ImageDetailsContract>(this.moderateUrl, formData, { params })
            .pipe(map((contracts) => new Image(contracts)));
    }

    getImage(id: string): Observable<Image> {
        const url = this.routingHelpersService.combineUrl(this.baseUrl, id);
        return this.http
            .get<ImageDetailsContract>(url)
            .pipe(map((contract) => new Image(contract)));
    }
}
